class Slider {
	constructor() {
		let cache = {};

		let initFunc = () => {
			initCache();
			registerEvents();
		};

		let initCache = () => {
			cache.images = Array.from(document.querySelectorAll(".slider-image"));
			cache.currentIndex = 0;
		};

		let registerEvents = () => {
			shuffleImages();

			displayImage(cache.currentIndex);

			setInterval(() => {
				cache.currentIndex = (cache.currentIndex + 1) % cache.images.length;
				displayImage(cache.currentIndex);
			}, 4000);
		};

		let shuffleImages = () => {
			let shuffled = [...cache.images];
			for (let i = cache.images.length - 1; i > 0; i--) {
				const j = Math.floor(Math.random() * (i + 1));
				[shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
			}

			for (let i = 0; i < shuffled.length - 1; i++) {
				const imgSrc1 = shuffled[i].getAttribute("src");
				const imgSrc2 = shuffled[i + 1].getAttribute("src");

				if (
					(imgSrc1.includes("slider_4.jpg") &&
						imgSrc2.includes("slider_5.jpg")) ||
					(imgSrc1.includes("slider_5.jpg") && imgSrc2.includes("slider_4.jpg"))
				) {
					const swapIndex = (i + 2) % shuffled.length;
					[shuffled[i + 1], shuffled[swapIndex]] = [
						shuffled[swapIndex],
						shuffled[i + 1],
					];
				}
			}

			cache.images = shuffled;
		};

		let displayImage = (index) => {
			cache.images.forEach((img, i) => {
				img.style.opacity = i === index ? "1" : "0";
			});
		};

		initFunc();
	}
}

export { Slider };
